import axios from 'axios'
import api from './http'
import { generateHeaders, generateHeadersByKeyAndSecret } from './sign'

const TRACKING_METHOD = 'api.burton.tracking.report.2812'
const TRACKING_ROUTE = '/dw/admin/api/tracking/route/rest'
const DEFAULT_APP_KEY = 'weinxqlhhktop'
const burtonClient = axios.create({
  timeout: 120000
})

function toSafeJson(value) {
  if (!value) return null
  if (typeof value === 'object') return value
  try {
    return JSON.parse(value)
  } catch (error) {
    return null
  }
}

function getAuthUser() {
  return toSafeJson(localStorage.getItem('auth-user')) || {}
}

async function buildTrackingHeaders() {
  const authUser = getAuthUser()
  const appKey =
    authUser.appKey ||
    authUser.loginName ||
    authUser.login_name ||
    DEFAULT_APP_KEY
  const appSecret = authUser.appSecret

  if (appKey && appSecret) {
    return generateHeadersByKeyAndSecret(appKey, appSecret)
  }

  return generateHeaders(DEFAULT_APP_KEY)
}

export async function fetchBurtonTracking(requestBody) {
  const headers = await buildTrackingHeaders()
  const response = await api.post(
    TRACKING_ROUTE,
    {
      method: TRACKING_METHOD,
      requestBody
    },
    headers
  )
  if (!response || response.code !== 200 || !response.success) {
    throw new Error(response?.errorMsg || '查询Burton访问数据失败')
  }
  return Array.isArray(response.data) ? response.data : []
}

export const BURTON_CONFIG_IAP = 'iap'
export const BURTON_CONFIG_OFFICIAL = 'official'

function pickBurtonVariantConfig(config, variant = BURTON_CONFIG_IAP) {
  if (!config || typeof config !== 'object') return {}
  const target =
    config[variant] ||
    config[variant === BURTON_CONFIG_OFFICIAL ? 'officialMiniProgram' : 'innerPurchase'] ||
    null

  if (target && typeof target === 'object') {
    return {
      ...target,
      realtime_refresh_seconds:
        target.realtime_refresh_seconds ??
        config.realtime_refresh_seconds ??
        config.realtimeRefreshSeconds,
      dashboard_refresh_minutes:
        target.dashboard_refresh_minutes ??
        config.dashboard_refresh_minutes ??
        config.dashboardRefreshMinutes
    }
  }

  if (variant === BURTON_CONFIG_IAP && (config.url || config.account || config.pwd)) {
    return config
  }

  return {}
}

export async function getBurtonStoreConfig(variant = BURTON_CONFIG_IAP) {
  const response = await api.get('/auth/api/v1/dict/code/burton_config')
  if (!response || response.code !== 200) {
    throw new Error(response?.errorMsg || '获取Burton配置失败')
  }

  const dictData = response?.data || {}
  const dictValue = dictData?.value
  const rawConfig = toSafeJson(dictValue) || dictData || {}
  const config = pickBurtonVariantConfig(rawConfig, variant)
  if (!config.url || !config.account || !config.pwd) {
    throw new Error(
      variant === BURTON_CONFIG_OFFICIAL
        ? 'Burton正式小程序配置缺少url/account/pwd'
        : 'Burton内购配置缺少url/account/pwd'
    )
  }
  return config
}

export async function loginBurtonStore(config) {
  const response = await burtonClient.post(
    `${config.url}/api/v2/auth/login`,
    {
      username: config.account,
      password: config.pwd
    },
  )

  const token = response?.data?.data?.token
  if (!token) {
    throw new Error(response?.data?.errorMsg || 'Burton服务登录失败')
  }
  return token
}

export async function execBurtonOrderSql(config, token, sql, pageQuery) {
  const requestBody = { sql }
  if (pageQuery && typeof pageQuery === 'object') {
    requestBody.pageQuery = pageQuery
  }
  const response = await burtonClient.post(
    `${config.url}/api/v2.2/dbTools/mysql/execCommand`,
    requestBody,
    {
      headers: {
        token,
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
    }
  )

  if (!response?.data?.success) {
    throw new Error(response?.data?.errorMsg || '执行Burton订单SQL失败')
  }

  return response?.data?.data || {}
}

export async function fetchBurtonDataBoard(config, token, requestBody) {
  const response = await burtonClient.post(
    `${config.url}/api/v2.1/DataBoard`,
    requestBody,
    {
      headers: {
        token,
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
    }
  )

  if (!response?.data?.success && response?.data?.code && response?.data?.code !== 200) {
    throw new Error(response?.data?.errorMsg || response?.data?.message || '查询Burton访问数据失败')
  }

  const data = response?.data?.data ?? response?.data
  if (Array.isArray(data)) return data
  if (Array.isArray(data?.records)) return data.records
  if (Array.isArray(data?.list)) return data.list
  if (Array.isArray(data?.rows)) return data.rows
  return []
}
